define("powergen/views/application",
  [],
  function() {
    "use strict";
    var ApplicationView;

    ApplicationView = Ember.View.extend({
      tagName: 'section',
      classNames: ['ember-application'],
      click: function(e) {
        return this.get('controller').send('viewDidClick', e);
      },
      didInsertElement: function(e) {
        return FastClick.attach(document.body);
      }
    });


    return ApplicationView;
  });